import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { upcomingAudiobooks } from '@/mocks/audiolibros';

export default function Audiolibros() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Hero — Audiolibros próximamente */}
      <section className="relative min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
        <img
          src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/6a9b137b-25f5-492a-82d8-48a65bca7265_compressed_ChatGPT-Image-13-ago-2026-04_39_27-p.m.-1.webp"
          alt={t('audiolibros.hero.title')}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10"></div>

        <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 pt-28 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-xl">
            <span className="inline-block font-sans text-xs md:text-sm font-semibold text-white uppercase tracking-[0.2em] mb-5 bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              {t('audiolibros.hero.badge')}
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
              {t('audiolibros.hero.title')}
            </h1>
            <p className="font-serif text-lg md:text-xl text-white/90 italic mb-6">
              {t('audiolibros.hero.subtitle')}
            </p>
            <p className="font-sans text-sm md:text-base text-white/85 leading-relaxed max-w-lg">
              {t('audiolibros.hero.desc')}
            </p>
          </div>
        </div>
      </section>

      {/* En producción */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('audiolibros.produccion.tag')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('audiolibros.produccion.title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] leading-relaxed max-w-2xl mx-auto">
              {t('audiolibros.produccion.desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {upcomingAudiobooks.map((item) => (
              <div
                key={item.id}
                className="bg-cream rounded-2xl p-6 md:p-7 border border-sand/40 flex flex-col items-start"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-terracotta/15 text-terracotta mb-5">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-sans text-xs font-semibold text-[#5C4A3A] uppercase tracking-wider mb-2">
                  {item.format}
                </span>
                <h3 className="font-serif text-lg font-bold text-[#8B6F5C] mb-2 leading-tight">
                  {t(`audiolibros.items.${item.id}.title`, item.title)}
                </h3>
                <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-5">
                  {t(`audiolibros.items.${item.id}.desc`, item.description)}
                </p>
                <span className="mt-auto inline-flex items-center gap-1.5 font-sans text-xs font-semibold text-terracotta uppercase tracking-wider">
                  <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse"></span>
                  {t('audiolibros.item_badge')}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mientras tanto */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-sand">
        <div className="w-full max-w-4xl mx-auto text-center">
          <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
            {t('audiolibros.mientras.tag')}
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('audiolibros.mientras.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] leading-relaxed max-w-2xl mx-auto mb-8">
            {t('audiolibros.mientras.desc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/quiero-cambiar"
              className="inline-flex items-center justify-center bg-terracotta text-white px-8 py-4 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap w-full sm:w-auto"
            >
              {t('audiolibros.cta.button1')}
              <i className="ri-arrow-right-line ml-2" />
            </Link>
            <Link
              to="/conoce-el-metodo"
              className="inline-flex items-center justify-center bg-white text-[#3D2B1F] px-8 py-4 rounded-full font-sans text-sm font-semibold hover:bg-cream transition-colors duration-300 whitespace-nowrap w-full sm:w-auto"
            >
              {t('audiolibros.cta.button2')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}